import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { getWalletMock } from '@kr/mocks';
import { WalletCard } from '@kr/models';

import { WalletDetailsApiService } from '.';

@Injectable()
export class WalletDetailsMockApiService extends WalletDetailsApiService {
  override getWalletDetails(wallet: WalletCard): Observable<WalletCard> {
    const walletDetails = getWalletMock(+wallet.id);

    return of(walletDetails).pipe(delay(500));
  }

  override editWallet(): Observable<void> {
    return of(null).pipe(delay(500));
  }

  override deleteWallet(): Observable<void> {
    return of(null).pipe(delay(500));
  }
}
